(function () {
  'use strict';

  if (window.BundleStaffel) return;

  var DEFAULT_TIERS = [
    { minimum: 2, percent: 5 },
    { minimum: 3, percent: 10 },
    { minimum: 4, percent: 15 }
  ];

  function configTiers() {
    var config = window.BundleStaffelConfig;
    if (config && Array.isArray(config.tiers) && config.tiers.length) return config.tiers;
    return DEFAULT_TIERS;
  }

  function normalizeTiers(tiers) {
    var source = Array.isArray(tiers) && tiers.length ? tiers : configTiers();
    return source
      .map(function (tier) {
        return {
          minimum: Math.max(1, parseInt(tier.minimum, 10) || 1),
          percent: Math.max(0, Math.min(100, Number(tier.percent) || 0))
        };
      })
      .sort(function (a, b) { return a.minimum - b.minimum; });
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format((Number(cents) || 0) / 100);
  }

  function calculate(quantity, subtotalCents, tiers) {
    var normalized = normalizeTiers(tiers);
    var count = Math.max(0, parseInt(quantity, 10) || 0);
    var subtotal = Math.max(0, Math.round(Number(subtotalCents) || 0));
    var current = null;
    var next = null;

    normalized.forEach(function (tier) {
      if (count >= tier.minimum) current = tier;
      if (!next && count < tier.minimum) next = tier;
    });

    var currentPercent = current ? current.percent : 0;
    var previewCents = Math.round(subtotal * (100 - currentPercent) / 100);
    var additionalSavingsCents = next
      ? Math.round(subtotal * (next.percent - currentPercent) / 100)
      : 0;

    return {
      quantity: count,
      subtotalCents: subtotal,
      tiers: normalized,
      current: current,
      next: next,
      currentPercent: currentPercent,
      previewCents: previewCents,
      additionalSavingsCents: additionalSavingsCents,
      remaining: next ? Math.max(0, next.minimum - count) : 0
    };
  }

  function message(result) {
    if (!result.next) return 'Höchste Stufe erreicht.';
    return 'Noch ' + result.remaining + ' ' + (result.remaining === 1 ? 'Produkt' : 'Produkte')
      + ' für ' + result.next.percent + ' % mit Code ' + codeForTier(result.next) + '.';
  }

  function codeForTier(tier) { return tier ? 'BUNDLE' + tier.minimum : null; }

  function activeCode(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return null;
    for (var index = 0; index < cart.discount_codes.length; index += 1) {
      var discount = cart.discount_codes[index];
      if (discount && discount.applicable === true && typeof discount.code === 'string') return discount.code;
    }
    return null;
  }

  function setDiscounts(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (response) {
      if (!response.ok) throw new Error('Discount update failed');
      return response.json();
    });
  }

  function tiersFromElement(element) {
    if (!element) return normalizeTiers();
    var raw = element.getAttribute('data-bundle-tiers');
    if (!raw) return normalizeTiers();
    try {
      return normalizeTiers(JSON.parse(raw));
    } catch (error) {
      return normalizeTiers();
    }
  }

  function renderDrawer(cart) {
    var element = document.querySelector('[data-bundle-drawer-progress]');
    if (!element || !cart) return;
    var subtotal = cart.original_total_price == null ? cart.total_price : cart.original_total_price;
    var result = calculate(cart.item_count, subtotal, tiersFromElement(element));
    var text = element.querySelector('[data-bundle-drawer-message]');
    var track = element.querySelector('[data-bundle-drawer-track]');
    var highest = result.tiers[result.tiers.length - 1];
    var progress = highest ? Math.min(100, result.quantity / highest.minimum * 100) : 0;

    if (text) text.textContent = message(result);
    if (track) track.style.width = progress + '%';
  }

  window.BundleStaffel = {
    defaults: DEFAULT_TIERS.slice(),
    normalizeTiers: normalizeTiers,
    formatMoney: formatMoney,
    calculate: calculate,
    codeForTier: codeForTier,
    message: message,
    activeCode: activeCode,
    setDiscounts: setDiscounts,
    tiersFromElement: tiersFromElement,
    renderDrawer: renderDrawer
  };

  document.addEventListener('1a:cart:updated', function (event) {
    renderDrawer(event.detail);
  });
})();
